import { ShowFnOutput } from "mui-modal-provider";

export class DialogEventArgs {
  Dialog: ShowFnOutput<any> | undefined;
  IsCancelClose = false;
  DialogResult: DialogResult;
  Data: any;

  constructor(dialog: ShowFnOutput<any> | undefined, dlg_rslt: DialogResult, data: any) {
    this.Dialog = dialog;
    this.DialogResult = dlg_rslt;
    this.Data = data;
  }

}

export type DialogResult = "Yes" | "No" | "Cancel";